import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { TextField, Grid, Button, Box } from '@mui/material';

const validationSchema = Yup.object({});

interface GenelSabitleriProps {
    sabit: any;
    onUpdate: (updatedValues: any) => Promise<void>;
}

const GenelSabitleri: React.FC<GenelSabitleriProps> = ({ sabit, onUpdate }) => {

    const handleSubmit = async (values: any) => {
        const updatedValues = {
            ...sabit,
            guvenlikMetni: values.guvenlikMetni,
            belediyeMail: values.belediyeMail,
            belediyeAdres: values.belediyeAdres,
            belediyeTelefon: values.belediyeTelefon,
        };
        await onUpdate(updatedValues);
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                guvenlikMetni: sabit?.guvenlikMetni || '',
                belediyeMail: sabit?.belediyeMail || '',
                belediyeAdres: sabit?.belediyeAdres || '',
                belediyeTelefon: sabit?.belediyeTelefon || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, dirty }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id="guvenlikMetni"
                                name="guvenlikMetni"
                                label="Güvenlik Metni"
                                value={values.guvenlikMetni || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                multiline
                                fullWidth
                                variant="outlined"
                                sx={{
                                    '& .MuiInputBase-root': { height: '200px' },
                                    '& .MuiInputBase-input': { height: '100% !important', overflow: 'auto !important' },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="belediyeMail"
                                name="belediyeMail"
                                label="Belediye Mail"
                                value={values.belediyeMail || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="belediyeAdres"
                                name="belediyeAdres"
                                label="Belediye Adres"
                                value={values.belediyeAdres || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="belediyeTelefon"
                                name="belediyeTelefon"
                                label="Belediye Telefon"
                                value={values.belediyeTelefon || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box textAlign={{ xs: 'center', md: 'right' }}>
                                <Button type="submit" variant="contained" disabled={!dirty}>
                                    Kaydet
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};

export default GenelSabitleri;
